/*
    此文件为数据接口存放命名，为防止接口太多，造成接口混乱
    命名为大写斜杠
    按页面划分
    例如： 'ORDER_API': '/api/order',
    每个接口注释用途，为方面其他开发人员查找，了解。
    export default {

    }
*/
export default {
  /**查询公司-部门树 */
  LIST_COMPANY_API: '/maindata/company/listCompanyDepartmentTree',
  /**新增公司 */
  ADD_COMPANY_API: '/maindata/company/saveCompany',
  /**修改公司*/
  UPDATE_COMPANY_API: '/maindata/company/updateCompany',
  /**新增部门 */
  ADD_DEPARTMENT_API: '/maindata/department/saveDepartment',
  /**修改部门*/
  UPDATE_DEPARTMENT_API: '/maindata/department/updateDepartment',
  /**公司禁用启用*/
  UPDATE_STATUS_API: '/maindata/company/updateCurrentStatus',
  /**部门禁用启用*/
  UPDATE_DEPART_STATUS_API: '/maindata/department/updateCurrentsStatus',
  /**查看公司详情*/
  GET_COMPANY_DETAIL_API: '/maindata/company/getCompanyDetail',
  /**查看部门详情*/
  GET_DEPARTMENT_DETAIL_API: '/maindata/department/getDepartmentDetail',
  /**新增公司根据部门编码和名称查询*/
  GET_DEPARTMENT_LIST_API: '/maindata/department/listDepartmentPullDown',
  /**获取合作伙伴列表*/
  GET_PARTNER_LIST_API: '/maindata/partners/listPartner',
  /**获取公司下拉*/
  GET_COMPANY_LIST_API: '/maindata/company/listCompanyDropdown',
  /**获取控制范围*/
  GET_CONTROL_LIST_API: '/maindata/controlArea/listControlAreaDepartmentTree',
  /**新增控制范围*/
  ADD_SCONTROLAREA_API: '/maindata/controlArea/saveControlArea',
  /**修改控制范围*/
  UPDATE_CONTROLAREA_API: '/maindata/controlArea/updateControlArea',
  /**控制范围详情*/
  GET_CONTROL_AREA_API: '/maindata/controlArea/getControlAreaDetail',
  /**根据部门code查询出上级单位*/
  GET_PARENT_UNIT_API: '/maindata/department/iteratorCompanyDepartment',
  /**控制范围启用或禁用*/
  UPDATE_CONTROL_STATUS_API: '/maindata/controlArea/updateCurrentStatus',
  /**查询控制范围下拉*/
  GET_CONTROL_AREA_LIST: '/maindata/controlArea/listControlAreaDropdown',
  /**查询仓库列表*/
  GET_STORAGE_LIST: '/maindata/storage/listStorageByPage',
  /**新增仓库*/
  ADD_STORAGE_API: '/maindata/storage/saveStorage',
  /**仓库详情*/
  GET_STORAGE_DETAIL_API: '/maindata/storage/getStorageDetail',
  /**校验仓库重复*/
  GET_CHECKSTORAGE_API: '/maindata/storage/checkStorageName',
  /**修改仓库*/
  UPDATE_STORAGE_API: '/maindata/storage/updateStorage',
  /**禁用*/
  UPDATE_STORAGE_STATUS_API: '/maindata/storage/updateCurrentStatus',
  /**导入*/
  IMPORT_COMPANY_API: '/maindata/company/importCompany',
  /**历史记录*/
  GET_HISTORY_LIST: '/maindata/dataHistory/listDataHistory',
  /**导出*/
  EXPORT_COMPANY_API: '/maindata/company/exportCompany',
  /*导出仓库**/
  EXPORT_WAREHOUSE_API: '/maindata/storage/exportStorageExcel',
  /**导入仓库*/
  IMPORT_WAREHOUSE_API: '/maindata/storage/importStorageExcel',
  //审批通过 驳回
  UPDATE_IS_REJECT: '/maindata/storage/batchApprovalStorage',
  // 获取组织主数据 公司
  GET_COMPANY_API: '/maindata/person/listPerson',
  // 放弃
  GIVE_WAREHOSE_API: '/maindata/storage/renounceStorage',
  // 获取MDG仓库、查重接口
  CHECK_MDG_WAREHOUSE: '/maindata/storage/checkMdgStorageMap',
  // 根据公司code列表获取部门
  GET_COMPANY_INFO_BY_CODE: '/maindata/company/getCompanyInfoByCompanyCodes',
};
